import React from 'react';

function Events() {
	return (
		<div>

			<div className="panel large pt-20l-10s">
				<div className="grid-x bg-fafafa b1-ddd p-20l-10s">
					<div className="large-12 medium-12 small-12 cell">
						<div className="font-libre-baskerville  font-size-18 font-weight-700 text-left hide-for-small-only">Title</div>
						<div className="font-libre-baskerville  font-size-18 font-weight-700 text-center show-for-small-only">Title</div>
						<div className="font-source-sans font-size-18l-16m-14s font-weight-500 line-height-120per justify pt-20">
						This is the Events page content.
						</div>
					</div>
				</div>
			</div>

			<div className="panel large pt-20l-10s">
				<div className="grid-x bg-fafafa b1-ddd p-20l-10s">
					<div className="large-12 medium-12 small-12 cell">
						<div className="font-libre-baskerville  font-size-18 font-weight-700 text-left hide-for-small-only">Title</div>
						<div className="font-libre-baskerville  font-size-18 font-weight-700 text-center show-for-small-only">Title</div>
						<div className="font-source-sans font-size-18l-16m-14s font-weight-500 line-height-120per justify pt-20">
						This is the Events page content.
						</div>
					</div>
				</div>
			</div>

		</div>
	);
}

export default Events;